import { useEffect, useRef } from 'react';
import { usePostHog } from 'posthog-js/react';
import type { CurrentUserInterface } from '@/shared/auth/model/types';

export const usePostHogIdentify = (user: CurrentUserInterface | null) => {
  const posthog = usePostHog();
  const identifiedUserIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (!posthog) {
      return;
    }

    if (user?.id && identifiedUserIdRef.current !== user.id) {
      posthog.identify(user.id, {
        email: user.email,
        name: user.displayName,
        role: user.role,
        shopId: user.currentShopId,
        isDemo: user.isDemo,
      });
      identifiedUserIdRef.current = user.id;
    } else if (!user && identifiedUserIdRef.current) {
      posthog.reset();
      identifiedUserIdRef.current = null;
    }
  }, [posthog, user]);
};
